"use client";
import SideRailContent from "./renderSideRailContent";
import { extractComponentNames } from "@/utils/getSortedComponentsBySectionOrder";
import { SideRailComponentProps, ComponentListProps } from "../types";

interface Props {
  sideRailHeaderComponents: SideRailComponentProps[] | undefined;
  sideRailBodyComponents: SideRailComponentProps[] | undefined;
}

export default function FullSizeContent({
  componentList,
  sideRailHeaderComponents,
  sideRailBodyComponents,
}: Props & ComponentListProps) {
  const defaultSideRailHeaderComponents: SideRailComponentProps[] = [
    { component: "sideRailTitle" },
    { component: "videoPlayer" },
    { component: "rating" },
  ];
  const headerComponents =
    sideRailHeaderComponents ?? defaultSideRailHeaderComponents;

  const defaulSideRailBodyComponents: SideRailComponentProps[] = [
    { component: "pricing" },
    { component: "ctaButton" },
    { component: "programSkills" },
    { component: "programCourses" },
    { component: "imageTitle" },
    { component: "endorsements" },
    { component: "industryInsights" },
    { component: "partnerLogo" },
  ];
  const bodyComponents = sideRailBodyComponents ?? defaulSideRailBodyComponents;

  return (
    <SideRailContent
      components={componentList}
      headerComponentsOrder={extractComponentNames(headerComponents)}
      bodyComponentsOrder={extractComponentNames(bodyComponents)}
    />
  );
}
